export default (loadData, { onEnter = true, onUpdate = true } = {}) => {
  let loaderCallback = () => {}

  const loadRoute = (to, from, next) => {
    loadData(to, (callback) => {
      loaderCallback = callback
      next()
    })
  }

  return {
    beforeRouteEnter: onEnter ? loadRoute : null,
    beforeRouteUpdate: onUpdate ? loadRoute : null,
    created: function() {
      loaderCallback.apply(this)
    },
    watch: {
      '$route': function() {
        loaderCallback.apply(this)
      }
    }
  }
}
